import { getPurchaseDouyinSignature, getPurchaseDouyinUserinfo } from '@/api/douyin';
import { isDouyinApp } from './index';


const sdk = window.DouyinOpenJSBridge;
const sdkopen = window.douyin_open;

let clientKey = '';
let url = location.href;

function getConfigParams() {
  return new Promise((resolve, reject) => {
    getPurchaseDouyinSignature({ url }).then(res => {
      let { client_key, signature, timestamp, nonce_str } = res.data;
      clientKey = res.data.client_key;
      sdk.config({
        params: {
          client_key,
          signature,
          timestamp,
          nonce_str,
          url
        }
      });

      sdk.ready((res) => {
        // alert('ready');
        resolve();
      });
      sdk.error(err => {
        // alert('not_ready~~~~~' + JSON.stringify(err));
        resolve();
      });
    }).catch(err => {
      resolve();
    });
  });
}

async function init() {
  if (isDouyinApp()) {
    await getConfigParams();
  }
}

init();

export function douyinAuth() {
  return new Promise((resolve, reject) => {
    sdkopen.showOpenAuth({
      params: {
        client_key: clientKey,
        redirect_uri: '',
        state: '',
        scopes: {
          user_info: 0,
          mobile: 0,
        },
        response_type: 'code'
      },
      success: res => {
        getPurchaseDouyinUserinfo({ code: res.ticket }).then(res => {
          resolve(res);
        }).catch(err => {
          // alert('调凤生用户信息错误~~~~~' + JSON.stringify(err));
          resolve(err);
        });
      },
      error: res => {
        // alert('调授权错误~~~~~' + JSON.stringify(res));
        reject(res);
      }
    });
  });
}

